<div class="n-breadcrumb d-flex align-items-center justify-content-between">
    <ol class="breadcrumb m-0 bg-transparent p-0">
        <li class="breadcrumb-item"><a href="/#/dealer/home">Home</a></li>
        <li class="breadcrumb-item"><a href="/#/subscriptions/managesubscriptions">Manage Subscriptions</a></li>
        <li class="breadcrumb-item active">Enrolled Dealers</li>
    </ol>
    <div class="breadcrumb-toolbar" >
        <a (click)="backtogrid()" class="font-size-sm"><i class="la la-angle-left"></i> Back</a>
    </div>
   
</div>
<div class="panel-tile main-title d-flex align-items-center justify-content-between">
    <h3 style="border: 0px !important;margin: 0;padding: 0 !important;" i18n>Enrolled Dealers</h3>
</div>
<div><br>
    <div class="alert alert-success" [hidden]="isSuccessMessage" role="alert">
        {{successMessage}}
    </div>
    
    <div class="panel-group search-criteria mb-1" id="accordion" role="tablist" aria-multiselectable="true">
        <div class="panel panel-default bg-white m-0">
            <div class="panel-heading" role="tab" id="headingTwo" (click)="searchClick(show=!show)"
                data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" aria-expanded="false"
                aria-controls="collapseTwo">
                <h6 class="panel-title1 d-flex align-items-center justify-content-between"
                    style="padding: 11px 15px; line-height: 1.1; font-size: 15px;">
                    <span>Search Criteria</span>
                    <a class="collapsed" role="button" style="font-size: 22px;">
                        <i class="{{toggleClass}}"></i>
                    </a>
                </h6>
            </div>
            <div id="collapseTwo" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo">
                <div class=" form-group d-flex p-2 ">
                    
                    <div class="d-inline-block m-2 ">
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" (keyup.enter)="bindDealerInfo()"
                                [(ngModel)]="searchText" placeholder="Search Dealer" aria-label="Recipient's username"
                                aria-describedby="button-addon2">
                        </div>
                    </div>
                    <div class="d-inline-block m-2 ">
                        <div class="input-group-append" (click)="bindDealerInfo()">
                            <button class="btn btn-primary" type="submit" id="button-addon2" #searchtxt>Search</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="tableinfo">
        <div class="alert alert-custom alert-secondary d-flex align-items-center flex-wrap"
            role="alert">
            <div class="col-6"  style="margin-left: -17px;">
                <div class="text-muted font-weight-bold">Subscription Name</div>
                <div class="text-dark-75 font-weight-bolder d-block font-size-lg">{{SubscriptionName}}</div>
            </div>
            <div class="col-6">
                <div class="text-muted font-weight-bold">Client Name </div>
                <div class="text-dark-75 font-weight-bolder d-block font-size-lg">{{ClientName}} </div>
            </div>
        </div>
    </div>
    <div class="tcard" style="box-shadow: 0 0 0 #eee;">
        <div class="tcard-body">
            <div class="prime-table p-0">
                <p-table #dt [columns]="dealerCols" [(selection)]="selectedvalues" [value]="dealers" [rows]="20"
                    [responsive]="true" class="mytable" emptymessage="customMessage" selectionMode="multiple"
                    dataKey="DealerGuid" id="dealerGrid">
                    <ng-template pTemplate="header">
                        <tr>
                            <th width="4%">
                                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>&nbsp;
                                <a href="javascript:void(0)" class="text-danger"><i class="flaticon-delete-1"
                                        title="Remove Dealer(s)"
                                        (click)="deleteSubscribedDealers()"></i></a>
                                <!-- <button class="btn btn-danger" type="submit" id="button-addon2"><i class="icon"></i></button> -->
                            </th>
                            <th width="5%">OEM</th>
                            <th width="6%">Natural Key</th>
                            <th width="12%">Dealer Name</th>
                            <th width="20%">Address </th>
                            <th width="10%">Data Provider</th>
                            <th width="12%">
                                Last File Processed Date
                            </th>
                            <th width="3%"><button type="button" class="btn" pButton (click)="downloadexcel(1)" style="float:right"
                                data-toggle="tooltip" data-placement="top" title="Export to Excel">
                                <i class="fa fa-file-excel-o" aria-hidden="true" style="font-size: 24px;"></i>
                            </button></th>
                            
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-rowData>
                        <tr>
                            <td>
                                <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                            </td>
                            <td>{{rowData.OemCode}}</td>
                            <td>{{rowData.NaturalKey}}</td>
                            <td>
                                {{rowData.DealerName}}
                            </td>
                            <td>{{rowData.Address1}}, 
                                {{rowData.City}}, 
                                {{rowData.State}}, 
                                {{rowData.Zip}}
                            </td>
                             <td> {{rowData.DataProvider}}</td>
                            <td>{{rowData.LastFileProcessedDate | date:'MM/dd/yyyy'}}</td>
                            <!--<td>{{rowData.State}}</td>
                            <td>{{rowData.Zip}}</td> -->
                            <td></td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
    <!-- pager -->
    <div class="customer-list-pagination">
        <ul *ngIf="pager && pager.pages && pager.pages.length" class="pagination">
            <li [ngClass]="{disabled:pager.currentPage === 1}">
                <a (click)="setPage(1)">
                    <span class="fa fa-step-backward"></span>
                </a>
            </li>
            <li [ngClass]="{disabled:pager.currentPage === 1}">
                <a (click)="setPage(pager.currentPage - 1)">
                    <span class="fa fa-backward"></span>
                </a>
            </li>
            <span class="paginator-numbers">
                <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                    <a (click)="setPage(page)">{{page}}</a>
                </li>
            </span>
            <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                <a (click)="setPage(pager.currentPage + 1)">
                    <span class="fa fa-forward"></span>
                </a>
            </li>
            <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                <a (click)="setPage(pager.totalPages)">
                    <span class="fa fa-step-forward"></span>
                </a>
            </li>
            <select class="selectbox-page" [(ngModel)]="NoofPages" (change)="onChange($event,pager.currentPage)">
                <option [value]="5">5</option>
                <option [value]="10">10</option>
                <option [value]="20">20</option>
            </select>
        </ul>
    </div>
    <p-dialog class="confirm-delete-modal required-modal" header="Subscription delete for Dealer(s)" [(visible)]="displaySubDlrDltDialog"
        [responsive]="true" showEffect="fade" [modal]="true">
        <div class="col-md-12" style="padding-bottom: 20px;">
            <div class="row">
                <div class="form-group col-md-12">
                    Are you sure you want to delete?
                </div>
            </div>
        </div>
        <p-footer class="req-footer">
            <div>
                <button type="submit" class="btn btn-light my-2 py-3 px-5" (click)="No()"
                    href="javascript:;">No</button>
                <button type="submit" class="btn btn-primary my-2 py-3 px-5" (click)="ConfirmDelete()"
                    href="javascript:;">Yes</button>
            </div>
        </p-footer>
    </p-dialog>
    <style>
        .panel-group .panel-title {
            border-bottom: none !important;
            font-size: 30px !important;
        }
    </style>
    <style>
        .customer-list-pagination {
            padding: 20px !important;
            background: #f8f9fb;
            border-color: #f8f9fb !important;
        }

        .customer-list-pagination .pagination {
            justify-content: center;
            margin-bottom: 0px;
        }

        .customer-list-pagination .pagination .disabled {
            width: auto;
        }

        .customer-list-pagination select.selectbox-page {
            margin-left: 10px;
            padding: 2px 10px;
            min-width: 60px;
            margin-top: -5px;
            border-color: #dfe1e4;
        }

        .customer-list-pagination .pagination li a {
            border: 0px;
            padding: 0.3rem 0.75rem;
            border: 1px solid #fff;
        }

        .paginator-numbers {
            display: inline-flex;
            margin: 0 20px;
        }

        .customer-list-pagination .pagination li.active a,
        .customer-list-pagination .pagination li.active:hover a {
            background-color: #186ba0;
            border-color: #fff;
            color: #fff;
        }

        .mytable table {
            border-collapse: collapse;
        }

        .mytable tr {
            padding: 2px;
            /* border: 1px solid #e1e7ec; */
        }

        /* .mytable tr td
        {
          padding:2px;
        } */
        /* .mytable tr.last
        {
          border-bottom: none;
        } */
        .mytable tr:last-child {
            border-bottom-style: hidden;
        }
    </style>